import { Check } from "lucide-react";
import { FadeUp } from "./anim";
import { useLead } from "./lead-context";
import { IMAGES } from "./site-data";

const INCLUDED = [
  "Integrated solar canopy panel",
  "Built-in grid-tie microinverter",
  "Cord-and-plug connected — no hardwiring",
  "Deep raised planter bed",
  "Weather-resistant premium build",
  "Made-to-order craftsmanship",
];

export const Pricing = () => {
  const { openLead } = useLead();
  return (
    <section
      id="pricing"
      className="relative bg-sg-bg py-24 sm:py-32 border-t border-sg-border/50"
      data-testid="pricing-section"
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid gap-10 lg:gap-16 lg:grid-cols-2 items-stretch">
          <FadeUp>
            <div className="max-w-lg">
              <span className="text-xs uppercase tracking-[0.25em] text-sg-primary">
                Ownership
              </span>
              <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-sg-fg">
                One garden. Years of return.
              </h2>
              <p className="mt-6 text-base text-sg-muted font-light leading-relaxed">
                Each Solar Garden is made to order and built to last. Pricing
                reflects the materials, the integrated solar system, and the
                craftsmanship that make it a lasting feature of your home.
              </p>

              <ul className="mt-8 grid sm:grid-cols-2 gap-x-8 gap-y-3">
                {INCLUDED.map((item) => (
                  <li key={item} className="flex items-start gap-2.5 text-sm text-sg-fg/85">
                    <span className="mt-0.5 grid place-items-center w-4 h-4 rounded-full bg-sg-primary/20 text-sg-primary shrink-0">
                      <Check size={11} strokeWidth={3} />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </FadeUp>

          <FadeUp delay={0.1} y={50}>
            <div
              className="relative h-full overflow-hidden rounded-3xl border border-sg-primary/25 bg-sg-card p-8 sm:p-10"
              data-testid="pricing-card"
            >
              <div
                className="absolute inset-0 opacity-25"
                style={{
                  backgroundImage: `url(${IMAGES.product1})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  maskImage: "linear-gradient(to bottom, transparent, black)",
                  WebkitMaskImage: "linear-gradient(to bottom, transparent, black)",
                }}
              />
              <div className="relative">
                <span className="text-xs uppercase tracking-[0.25em] text-sg-primary">
                  The Solar Garden
                </span>
                <h3 className="mt-5 font-display text-4xl sm:text-5xl tracking-tight text-sg-fg leading-tight">
                  Custom-built for your space
                </h3>
                <p className="mt-4 text-sm text-sg-muted leading-relaxed">
                  Pricing is determined on a project-by-project basis, based on
                  scope and materials. Tell us about your patio, balcony, or
                  backyard and we'll put together a tailored quote — no
                  obligation.
                </p>

                <div className="mt-9 flex flex-col gap-3">
                  <button
                    onClick={() => openLead("quote")}
                    data-testid="pricing-quote-btn"
                    className="w-full rounded-full bg-sg-primary px-6 py-3.5 text-sm font-medium text-sg-bg hover:bg-sg-fg transition-colors duration-300"
                  >
                    Request Your Quote
                  </button>
                  <button
                    onClick={() => openLead("waitlist")}
                    data-testid="pricing-waitlist-btn"
                    className="w-full rounded-full border border-sg-border px-6 py-3.5 text-sm font-medium text-sg-fg hover:border-sg-fg/50 transition-colors duration-300"
                  >
                    Join the Waitlist
                  </button>
                </div>
                <p className="mt-4 text-center text-xs text-sg-muted">
                  No payment today — we'll follow up personally.
                </p>
              </div>
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
};
